// extracted by mini-css-extract-plugin
export default {"zoomModal":"o1-z"};